const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Promote24 = function Promote24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.357 1.77C11.835 3.16 8.34 5.087 4 5.5c-1.65.157-3 1.343-3 3v1c0 1.657 1.347 2.843 2.997 3 4.346.413 7.85 2.343 10.374 3.734.31.17.606.334.886.484C16.784 17.54 19 16.234 19 14.5V3.293c0-1.734-2.216-2.837-3.743-2.016-.284.153-.584.318-.9.492ZM6 9a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
      clipRule: "evenodd",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M21 12.465A3.998 3.998 0 0 0 23 9c0-1.48-.804-2.773-2-3.465v6.93ZM10.769 16.597c-1.857-.905-3.974-1.726-6.393-2.042l1.156 6.012A3 3 0 0 0 8.478 23h1.1a2 2 0 0 0 1.965-2.378l-.774-4.025Z",
    })
  );
};
Promote24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
};
const sizeMap = {
  24: Promote24,
};
export function Promote(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Promote' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
